import { api } from '@ezugi/utils';

import { OUTGOING_CALLS } from '../endpoints';

export const fetchOutgoingCalls = () => api.get(OUTGOING_CALLS);
